import { useQuery } from "@tanstack/react-query";
import type { FreshnessMeta } from "@/lib/api";
import { getPool } from "./api";
import { MaterialsTab } from "./materials/MaterialsTab";
import { LogTab } from "./log/LogTab";
import { PoolTab } from "./pool/PoolTab";
import { PurchasesTab } from "./purchases/PurchasesTab";

export function useRawMaterialsMeta(enabled: boolean): FreshnessMeta | null | undefined {
  const head = useQuery({ queryKey: ["raw_materials", "pool", "all", null], queryFn: () => getPool("all", null), enabled });
  return enabled ? head.data?.meta : undefined;
}
export function RawMaterialsModule({ activeTabKey, areaName }: { decision: "edit" | "view" | "none"; activeTabKey: string | null; areaName: string; ownerName?: string | null }) {
  switch (activeTabKey) {
    case "materials": return <MaterialsTab areaName={areaName} />;
    case "log": return <LogTab areaName={areaName} />;
    case "purchases": return <PurchasesTab areaName={areaName} />;
    default: return <PoolTab areaName={areaName} />;
  }
}
